import { css } from "@mds/core";

export const layoutCSS = css`
	@supports (--foo: "mds") {
		/* 	###################################################################### */
		/**	Component tokens
			   Use the design tokens to set these component tokens.
		   */
		:host {
			--display: grid;
			--direction: unset;
			--background-color: var(--mds-color-background-light);
			--rows: 1fr;
			--row: 1;
			--columns: 1fr;
			--column: 1 / -1;
			--column-count: auto-fit;
			--sub-columns: auto;
			--align: start;
			--pad-responsive: 1rem;
			--pad-responsive-viewport: 0;
			--pad-responsive-layout: 0;
			--gap: 0;
			--offset-start: 0;
			--offset-end: 0;
		}

		/* 	###################################################################### */
		/**	Layout container rules
			  This is the main rule set.
		   */
		:host {
			display: var(--display, grid);
			box-sizing: border-box;
			grid-template-columns: var(--columns);
			grid-template-rows: var(--rows);
			gap: var(--pad-responsive);
			padding: var(--pad-responsive-layout) var(--pad-responsive-viewport);
			font-family: var(--mds-typography-font-base-fonts);
			font-size: calc(
				var(--mds-typography-scale-increment-body) *
					var(--mds-typography-font-size) * 1rem
			);
			line-height: var(--mds-typography-font-height);
			font-weight: var(--mds-typography-font-base-weight-normal);
			color: var(--mds-color-text-default);
			-moz-text-size-adjust: none;
			-webkit-text-size-adjust: none;
			text-size-adjust: none;
			background-color: var(--background-color);
			margin: 0 auto;
			width: 100%;
			max-width: var(--mds-spacing-layout-max);
		}

		:host([type="split"]) {
			padding-block: var(--pad-responsive-layout);
			padding-inline: 0;
		}

		:host([type="stacked"]) ::slotted(*) {
			max-width: calc(var(--mds-spacing-layout-content-max) * 0.66);
		}

		:host([type="full"]) {
			padding: 0;
		}

		/* 	###################################################################### */
		/**	Subgrid rules
			  This is the rule set for slots
		   */
		::slotted(*) {
			display: var(--display, grid);
			flex-direction: var(--direction, unset);
			align-items: var(--align);
			grid-template-columns: var(--sub-columns, 1fr);
			grid-template-rows: repeat(auto-fit, 1fr);
			gap: var(--pad-responsive);
			grid-column: var(--column);
			grid-row: var(--row);
		}

		/* 	###################################################################### */
		/**	Properties for the main layout */

		:host([zebra="even"]) {
			--background-color: var(--mds-color-background-light);
			--order: 1;
			--justify: start;
			--offset-start: var(--pad-responsive);
			--offset-end: var(--pad-responsive-viewport);
		}
		:host([zebra="odd"]) {
			--background-color: var(--mds-color-background-pale);
			--order: 2;
			--justify: end;
			--offset-start: var(--pad-responsive-viewport);
			--offset-end: var(--pad-responsive);
		}
		:host([type="asymmetric"]) {
			--columns: 1fr 1fr 1fr;
		}

		:host([type="cards"]) {
			--columns: 1fr;
			--column-count: auto-fit;
			--sub-columns: repeat(
				var(--column-count, auto-fit),
				minmax(25ch, 1fr)
			);
		}

		:host([type="stacked"]) {
			--columns: 1fr;
			--display: block;
			--sub-columns: 1fr;
		}

		/* 	###################################################################### */
		/**	Properties for the sub layout */
		/* Header slots */
		::slotted([slot="navigation"]) {
			--column: 1 / -1;
			--row: 1;
		}

		/* Header slots */
		::slotted([slot="header"]) {
			--column: 1 / -1;
			--row: 1;
		}

		/* Main slots */
		::slotted([slot="main"]) {
			--column: 1 / -1;
			--row: auto;
		}

		:host([type*="asymmetric"]) ::slotted([slot="main"]) {
			--display: block;
		}

		:host([type="asymmetric"][sidebar="left"]) ::slotted([slot="main"]) {
			--column: 2 / -1;
		}

		:host([type="asymmetric"][sidebar="right"]) ::slotted([slot="main"]) {
			--column: 1 / -2;
		}

		/* Aside slots */
		::slotted([slot="aside"]) {
			--row: auto;
		}

		:host([type*="asymmetric"]) ::slotted([slot="aside"]) {
			--display: block;
			--row: 2;
		}

		:host([type="asymmetric"][sidebar="left"]) ::slotted([slot="aside"]) {
			--column: 1 / 2;
		}

		:host([type="asymmetric"][sidebar="right"]) ::slotted([slot="aside"]) {
			--column: -2 / -1;
		}

		/* navigation slot */
		:host([type="full"]) ::slotted([slot="navigation"]) {
			--column: 1 / -1;
		}

		/* Footer slots */
		::slotted([slot="footer"]) {
			--column: 1 / -1;
			--row: -1; /* Always the last row */
		}
	}
`;
